Vue.component('EcoPartPrivateCopying', {
    props: {
        id: {
            type: String,
            required: true
        },
        ecoPartLabel: {
            type: String,
            required: true
        },
        ecoPartLinkLabel: {
            type: String,
            required: true
        },
        ecoPartModal: {
            type: Object,
            required: true
        },
        privateCopyingLabel: {
            type: String,
            default: null
        },
        privateCopyingLinkLabel: {
            type: String,
            required: true
        },
        privateCopyingLink: {
            type: String,
            required: true
        },
        target: {
            type: String,
            required: false,
            default: "_self"
        }
    },
    computed: {
        ecoPartModalId: function () {
            return this.ecoPartModal.id
        },
        ecoPartModalTitle: function () {
            return this.ecoPartModal.title
        },
        ecoPartModalText: function () {
            return this.ecoPartModal.text
        },
        privateCopyingLabelText:function (){
            return this.privateCopyingLabel ? ` ${this.privateCopyingLabel}` : '.'

        },
        privateCopyingLinkText: function () {
            return this.privateCopyingLabel ? `${this.privateCopyingLinkLabel}.` : '';
        },
        ecoPartLinkLabelText:function (){
            return ' ' + this.ecoPartLinkLabel
        }
    },
    template: `
      <div class="eco-part small pt-0">
      <p class="mb-0 p-0 d-inline">
        <span>{{ ecoPartLabel }}</span>
        <ob1-liens class="p-0" type="button"
                   :is-button="true"
                   :modal-id="ecoPartModalId"
                  :text="ecoPartLinkLabelText"></ob1-liens><span>{{ privateCopyingLabelText }}   <!--/*  laisser  </ob1-liens><span> collés  */-->
          <a class="ob1-link pb-0" :href="privateCopyingLink"
             :target="target">{{ privateCopyingLinkText }}</a>
        </span>
      </p>
      <ob1-popin-modal2 :id="ecoPartModalId" :aria-labelledby="id">
        <h4 :id="id">{{ ecoPartModalTitle }}</h4>
        <p v-html="ecoPartModalText"></p>
      </ob1-popin-modal2>
      </div>
    `
})
